import { multiply, division, reduce, ceil } from '@/utils/math';
import {
	CHARGE_RATIO,
	CHARGE_RATIO_PAY_TO_USER,
	MAX_PRICE,
	chargeComputed,
	amountComputed,
} from '@/utils/priceSetting';

export const getFileName = (file) => {
	const type = file.type.split('/')[1];
	const reg = new RegExp(`.${type}$`, 'g');
	if (reg.test(file.name)) {
		return file.name;
	} else {
		return `${file.name}.${type}`;
	}
};
export function getElement(selector, all) {
	if (selector instanceof Element) {
		return selector;
	}
	return all ? document.querySelectorAll(selector) : document.querySelector(selector);
}
function getRealBody() {
	return document.documentElement.scrollTop ? document.documentElement : document.body;
}
// dom是否触底
export const reachBottom = (ele, offset, all) => {
	let element = ele ? getElement(ele, all) : getRealBody();
	let b = offset || 300;
	const scrollTop = element.scrollTop;
	const clientHeight = ele ? element.clientHeight : document.documentElement.clientHeight;
	const scrollHeight = element.scrollHeight;
	return scrollHeight - clientHeight - scrollTop < b;
};

export const downloadUrlFile = (url, name, cb) => {
	const xhr = new XMLHttpRequest();
	xhr.open('GET', url, true);
	xhr.responseType = 'blob';
	xhr.onload = () => {
		if (xhr.status === 200) {
			// 获取图片blob数据并保存
			saveAs(xhr.response, name, cb);
		}
	};
	xhr.send();
};

function saveAs(blob, name, cb) {
	const nb = new Blob([blob], {
		type: blob.type,
	});
	if (navigator.msSaveOrOpenBlob) {
		navigator.msSaveOrOpenBlob(nb, name + '.png');
	} else {
		const url = URL.createObjectURL(nb);
		const atDom = document.createElement('a');
		atDom.setAttribute('href', url);
		// atDom.setAttribute('download', 'download');
		atDom.download = name;
		document.body.appendChild(atDom);
		atDom.click();
		setTimeout(() => {
			document.body.removeChild(atDom);
			cb && cb();
		}, 200);
	}
}

const motor = (left, top, l_step, t_step, element) => {
	requestAnimationFrame(() => {
		const c_top = element.scrollTop;
		const c_left = element.scrollLeft;
		if (element.scrollHeight - element.clientHeight <= element.scrollTop) {
			return;
		}
		if (Math.abs(left - c_left) < 10 && Math.abs(top - c_top) < 10) {
			return;
		}
		scrollTo({ left: c_left - l_step, top: c_top - t_step, element });
		motor(left, top, l_step, t_step, element);
	});
};
export const scrollTo = ({ left, top, element, animation, time }) => {
	// const element = el ? el : getRealBody();
	if (!element) {
		scrollTo({ left, top, element: document.body, animation, time });
		scrollTo({
			left,
			top,
			element: document.documentElement,
			animation,
			time,
		});
		return;
	}

	if (!animation) {
		try {
			element.scrollTo(left, top);
			element.scrollTop = top;
			element.scrollLeft = left;
		} catch (e) {
			element.scrollTop = top;
			element.scrollLeft = left;
		}
	} else {
		time = time || 1200;
		const c_top = element.scrollTop;
		const c_left = element.scrollLeft;

		if (c_top === top && c_left === left) {
			return;
		}
		left = isNaN(left) ? c_left : left;
		top = isNaN(top) ? c_top : top;

		const l_dur = c_left - left;
		const t_dur = c_top - top;

		const t_step = t_dur / (time / 60);
		const l_step = l_dur / (time / 60);
		motor(left, top, l_step, t_step, element);
	}
};

export const byteLength = (text, maxLen) => {
	var b = 0;
	var l = text.length; //初始化字节数递加变量并获取字符串参数的字符个数
	if (l) {
		//如果存在字符串，则执行计划
		for (var i = 0; i < l; i++) {
			//遍历字符串，枚举每个字符
			if (text.charCodeAt(i) > 255) {
				//字符编码大于255，说明是双字节字符
				b += 2; //则累加2个
			} else {
				b++; //否则递加一次
			}
		}
	}
	if (maxLen) {
		return b <= maxLen;
	} else {
		return b;
	}
};
// 返回len个字符长度得text
export const cutstrByLen = (text = '', len = 0) => {
	var b = len;
	var l = text.length; //初始化字节数递加变量并获取字符串参数的字符个数
	var s = '';
	if (l) {
		//如果存在字符串，则执行计划
		for (var i = 0; i < l; i++) {
			//遍历字符串，枚举每个字符
			if (text.charCodeAt(i) > 255) {
				//字符编码大于255，说明是双字节字符
				b -= 2; //则减去2
			} else {
				b--; //否则递减一次
			}
			if (b >= 0) {
				s += text[i];
			} else {
				break;
			}
		}
	}
	return s;
};

// 修浮点数
// https://github.com/camsong/blog/issues/9
export function strip(num, precision = 12) {
	return +parseFloat(num.toPrecision(precision));
}

// 时间格式化
export function formatDate(date, fmt) {
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	}
	let o = {
		'M+': date.getMonth() + 1,
		'd+': date.getDate(),
		'h+': date.getHours(),
		'm+': date.getMinutes(),
		's+': date.getSeconds(),
	};
	for (let k in o) {
		if (new RegExp(`(${k})`).test(fmt)) {
			let str = o[k] + '';
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
		}
	}
	return fmt;
}

function padLeftZero(str) {
	return ('00' + str).substr(str.length);
}

export const overEllipsis = (val, total = 6) => {
	if (!val) {
		return;
	}
	let len = val.length;
	let num = 0;
	let arr = [];
	let overFlow = true;
	for (let i = 0; i < len; i++) {
		if (val.charCodeAt(i) > 255) {
			num += 2;
		} else {
			num++;
		}
		arr.push(val[i]);
		if (i >= len - 1) {
			overFlow = false;
		}
		if (num >= total) {
			break;
		}
	}
	if (!overFlow) {
		return arr.join('');
	}
	return arr.join('') + '...';
};

export const calcDeductionAmount = (amount, notFen = false) => {
	let money = Number(amount);
	if (isNaN(money)) {
		console.error('计算抵扣金额需要传入正整数，单位为分');
		return false;
	}
	// amount 需要为分
	if (notFen) {
		money = multiply(money, 100);
	}
	if (parseInt(money) == money) {
		if (notFen) {
			return division(amountComputed(money, 0.006), 100);
		} else {
			return amountComputed(money, 0.006);
		}
	} else {
		console.error('计算抵扣金额需要传入正整数，单位为分');
		return false;
	}
};
